(function ($) {
    $('input.input-datepicker').datepicker({
        dateFormat: 'dd.mm.yy', minDate: 0,
        beforeShow: function() {
            setTimeout(function(){
                $('.ui-datepicker').css('z-index', 99999);
            }, 0);
        }
    });
})(jQuery);